// React
import Cleave from 'cleave.js/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Row, Card, CardBody, Button, Input } from 'reactstrap';

// Components
import { PageWrapper } from '../../containers/componentsInjection';

// Helpers & Redux
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import { CheckCpfProposal } from '../../../../store/actions';

const ProposalsCheckCpf = () => {
  const [cpf, setCpf] = useState();
  const [error, setError] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();

  function onCpfFormatChange(e) {
    if (!cpfValidator.isValid(e.target.rawValue)) {
      setError('Digite um CPF válido');
    } else {
      setError(null);
    }

    setCpf(e.target.rawValue);
  }

  const handleSubmit = () => {
    if (error || !cpf) {
      return false;
    }
    dispatch(CheckCpfProposal({ cpf, history }));
  };

  return (
    <PageWrapper title={'Nova Proposta'}>
      <Row>
        <Col xs={12}>
          <Card>
            <CardBody
              style={{
                padding: '20px',
              }}
            >
              <Row>
                <Col
                  md={12}
                  style={{
                    marginTop: '20px',
                  }}
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <div className="mb-3">
                      <label
                        htmlFor="cleave-date-format"
                        className="form-label"
                      >
                        Informe o CPF do titular
                      </label>
                      <Row>
                        <Col md={12}>
                          <Input
                            options={{
                              delimiters: ['.', '.', '-'],
                              blocks: [3, 3, 3, 2],
                              uppercase: true,
                            }}
                            value={cpf}
                            onChange={(e) => onCpfFormatChange(e)}
                            className="form-control"
                            tag={Cleave}
                            invalid={error}
                          />
                          <p className="labelErrorValidation">{error}</p>
                        </Col>
                        <Col
                          md={12}
                          style={{
                            marginTop: '10px',
                            justifyContent: 'end',
                            display: 'flex',
                          }}
                        >
                          <Button type="submit" className="float-right">
                            Pesquisar
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </form>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};

export default ProposalsCheckCpf;
